import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
  ApolloProvider as AProvider,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { ApplicationRecord } from "models";
import { ReactNode } from "react";
import { getEnv } from "tools";
import { errorLink } from "./errorLink";

const httpLink = createHttpLink({
  uri: `${getEnv("NEXT_PUBLIC_DEPOT_HOST")}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = ApplicationRecord.jwt;

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  };
});

export const apolloClient = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: getEnv("NODE_ENV") === "development",
});

export const ApolloProvider = ({ children }: { children: ReactNode }) => (
  <AProvider client={apolloClient}>{children}</AProvider>
);
